export const VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH = 'VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH'
export const VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH_SUCCESS = 'VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH_SUCCESS'
export const VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH_FAILURE = 'VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_FETCH_FAILURE'

export const VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_STATE_CLEAR = 'VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_STATE_CLEAR'

export const VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_STATE_UPDATE = 'VUEX_ASSORTMENT_SHOWROOM_PRODUCTS_STATE_UPDATE'
